export default class StructureEditorInterface {
  // Returns Promise - state readiness
  state = null;

  static _abstract() {
    Logger.error('Not implemented abstract method!');
  }

  getData() {
    this.constructor._abstract();
  }

  isEmpty() {
    this.constructor._abstract();
  }

  clear() {
    this.constructor._abstract();
  }

  loadStructure() {
    this.constructor._abstract();
  }

  onChange() {
    this.constructor._abstract();
  }

  onLoaded() {
    this.constructor._abstract();
  }
}
